<div class="content-wrapper coverage-report-layout">
  <div class="chart-section">
    <div class="chart-shortcuts-panel">
      <div class="chart-shortcuts-left">
        <div class="standard-chart-types">
          <button
            type="button"
            class="shortcut-btn"
            (click)="newReportMenu.toggle($event)"
          >
            Select Report...
          </button>
        </div>
      </div>
      <div class="chart-shortcuts-right" [formGroup]="chartFiltersForm">
        <span class="standard-chart-types__label report-quick-filter__label p-ml-2">Within Topic</span>
        <div class="report-quick-filters">
          <div class="report-quick-filter">
            <p-dropdown
              id="coverage-report-quick-domain-topic"
              formControlName="domainTopic"
              [options]="topicOptions"
              [appendTo]="'body'"
              (onChange)="onChartFilterChange()"
              styleClass="report-quick-dropdown"
            ></p-dropdown>
          </div>
          <span class="standard-chart-types__label report-quick-filter__label p-ml-2">Versus Competitors</span>
          <div class="report-quick-filter">
            <p-multiSelect
              id="coverage-report-quick-competitors"
              formControlName="competitorTopics"
              [options]="competitorOptions"
              [appendTo]="'body'"
              defaultLabel="(None)"
              selectedItemsLabel="{0} selected"
              [maxSelectedLabels]="1"
              [filter]="false"
              (onChange)="onChartFilterChange()"
              styleClass="report-quick-multiselect"
            ></p-multiSelect>
          </div>
          <span class="standard-chart-types__label report-quick-filter__label p-ml-2">Outlet Types</span>
          <div class="report-quick-filter">
            <p-multiSelect
              id="coverage-report-quick-outlet-groups"
              formControlName="outletGroups"
              [options]="outletGroupOptions"
              [appendTo]="'body'"
              defaultLabel="All Groups"
              selectedItemsLabel="{0} selected"
              [maxSelectedLabels]="1"
              [filter]="false"
              (onChange)="onQuickOutletGroupsChange($event.value)"
              styleClass="report-quick-multiselect report-quick-multiselect--groups"
            ></p-multiSelect>
          </div>
        </div>
        <button type="button" class="settings-toggle-btn" (click)="toggleChartSettings()">
          <i class="pi pi-cog"></i> Report Settings
        </button>
        <button type="button" class="save-chart-btn" (click)="saveChart()">
          <i class="pi pi-save"></i> Save Report
        </button>
      </div>
    </div>

    <!-- Loading skeleton (only shown for non-pie charts) -->
    <div class="chart-content" *ngIf="loadingChart">
      <div
        style="
          display: flex;
          align-items: flex-end;
          gap: 12px;
          width: 100%;
          height: calc(100% - 10px);
          min-height: 220px;
          padding: 1rem 2rem;
        "
        [style.height.px]="chartHeight"
      >
        <div style="flex: 1">
          <p-skeleton width="100%" height="80px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="130px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="100px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="160px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="110px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="180px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="140px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="200px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="120px" borderRadius="4px"></p-skeleton>
        </div>
        <div style="flex: 1">
          <p-skeleton width="100%" height="70px" borderRadius="4px"></p-skeleton>
        </div>
      </div>
    </div>

    <!-- Placeholder when no data (non-pie only) -->
    <div
      class="chart-content chart-placeholder"
      *ngIf="!loadingChart && !coverageDataChart"
      [style.height.px]="chartHeight"
    >
      <div class="placeholder-message">
        <i class="pi pi-chart-line" style="font-size: 3rem; color: #dee2e6"></i>
        <p class="p-mt-3" style="color: #6c757d; font-size: 1rem">
          No results available to generate the chart
        </p>
      </div>
    </div>

    <div id="coverage-chart-container" class="chart-content" *ngIf="!loadingChart && coverageDataChart" style="display: flex; flex-direction: row; ">
      <!-- Pie chart of the last interval -->
      <apx-chart class="coverage-pie-chart" *ngIf="isShowPieChart && coverageDataChart.pie" style="flex: 1; border: 1px solid #dee2e6; padding: 10px"
        [series]="pieChartOptions.nonAxisSeries"
        [labels]="pieChartOptions.labels"
        [chart]="pieChartOptions.chart"
        [title]="pieChartOptions.title"
        [subtitle]="pieChartOptions.subtitle"
        [colors]="pieChartOptions.colors"
        [stroke]="pieChartOptions.stroke"
        [markers]="pieChartOptions.markers"
        [dataLabels]="pieChartOptions.dataLabels"
        [plotOptions]="pieChartOptions.plotOptions"
        [legend]="pieChartOptions.legend"
        [tooltip]="pieChartOptions.tooltip"
      ></apx-chart>

      <!-- Main chart -->
      <apx-chart style="flex: 3; border: 1px solid #dee2e6; padding: 10px"
        [series]="
          chartOptions?.chart?.type === 'pie'
            ? chartOptions.nonAxisSeries
            : chartOptions.series
        "
        [labels]="chartOptions.labels"
        [chart]="chartOptions.chart"
        [title]="chartOptions.title"
        [subtitle]="chartOptions.subtitle"
        [colors]="chartOptions.colors"
        [stroke]="chartOptions.stroke"
        [markers]="chartOptions.markers"
        [dataLabels]="chartOptions.dataLabels"
        [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis"
        [plotOptions]="chartOptions.plotOptions"
        [grid]="chartOptions.grid"
        [legend]="chartOptions.legend"
        [tooltip]="chartOptions.tooltip"
      ></apx-chart>
    </div>
  </div>


  <div class="table-hidden-caption" *ngIf="!showCoverageTable">
    Click on a data point or interval in the chart to view more details
  </div>

  <div class="table-section report-table-region" *ngIf="showCoverageTable">
    <div
      class="active-filter-bar p-mx-2"
      *ngIf="
        coverageReportRequest?.timeframe === 'CUSTOM' ||
        (activeSearchFilters && searchFiltersLabel) ||
        chartClickFilter
      "
    >
        <div class="active-filter-bar__pills">
          <div
            class="filter-pill filter-pill--chart-topic"
            *ngIf="chartClickFilter"
          >
            <i class="pi pi-hashtag" style="font-size: 0.8rem"></i>
            <span>
              Topic: <strong>{{ chartClickFilter.topicName }}</strong>
            </span>
            <i
              class="pi pi-times filter-pill-remove"
              (click)="clearCustomFilter()"
            ></i>
          </div>
          <div
            class="filter-pill"
            *ngIf="activeSearchFilters && searchFiltersLabel"
          >
            <i class="pi pi-filter" style="font-size: 0.8rem"></i>
            <span
            >Filters: <strong>{{ searchFiltersLabel }}</strong></span
            >
            <i
              class="pi pi-times filter-pill-remove"
              (click)="clearSearchFilters()"
            ></i>
          </div>
          <div
            class="filter-pill"
            *ngIf="coverageReportRequest?.timeframe === 'CUSTOM'"
          >
            <i class="pi pi-calendar" style="font-size: 0.8rem"></i>
            <span
              >Date range:
              <strong>{{
                coverageReportRequest.from | date : 'MMM d yyyy'
              }}</strong>
              —
              <strong>{{
                coverageReportRequest.to | date : 'MMM d yyyy'
              }}</strong></span
            >
<!--          <i-->
<!--            class="pi pi-pencil filter-pill-remove"-->
<!--            style="color: #465675"-->
<!--            (click)="editCustomFilter()"-->
<!--          ></i>-->
<!--          <i-->
<!--            class="pi pi-times filter-pill-remove"-->
<!--            (click)="clearCustomFilter()"-->
<!--          ></i>-->
          </div>
          <button
            class="clear-all-filters-btn"
            (click)="clearAllFilters()"
          >
            <i class="pi pi-times"></i> Clear Filters
          </button>
        </div>
      </div>

    <!-- Authors table -->
    <ng-container *ngIf="isAuthorsDataType">
      <app-authors-tab
        [projectId]="projectId"
        [myCompanyQuery]="myCompanyQuery"
        [contentKeywords]="chartClickFilter?.keywords"
        [coverageReportRequest]="coverageReportRequest"
        [reportName]="reportName"
      ></app-authors-tab>
    </ng-container>

    <!-- Outlets table -->
    <ng-container *ngIf="isOutletsDataType">
      <app-outlets-tab
        [projectId]="projectId"
        [myCompanyQuery]="myCompanyQuery"
        [contentKeywords]="chartClickFilter?.keywords"
        [coverageReportRequest]="coverageReportRequest"
        [reportName]="reportName"
      ></app-outlets-tab>
    </ng-container>

    <!-- Default articles table -->
    <ng-container *ngIf="!isAuthorsDataType && !isOutletsDataType">
      <app-loading [isLoading]="loading"></app-loading>
      <p-table
        #coverageTable
        styleClass="p-datatable-sm"
        [value]="loading ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : coverageData"
        [scrollable]="true"
        scrollHeight="flex"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 10%">Date</th>
            <th style="width: 15%">Author</th>
            <th style="width: 15%">Outlet</th>
            <th style="width: 25%">Title</th>
            <th style="width: 35%">Excerpt</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr *ngIf="!loading">
            <td style="width: 10%">
              {{ item.publishDate | date : 'MMM dd, yyyy' }}
            </td>
            <td style="width: 15%">
              <div *ngIf="item.authorId" class="coverage-entity-cell">
                <app-star-toggle
                  [active]="isAuthorSaved(item)"
                  [isLoading]="savingAuthorId === item.authorId"
                  (toggled)="onAuthorStarToggled(item, $event)"
                ></app-star-toggle>
                <a
                  class="coverage-entity-link"
                  href="javascript:;"
                  role="button"
                  (click)="getAuthorContent(item)"
                  [pTooltip]="item.author"
                  tooltipPosition="top"
                >
                  <img
                    height="40px"
                    width="40px"
                    class="coverage-entity-avatar"
                    [src]="item.authorImageUrl"
                  />
                  <span class="coverage-entity-name">{{ item.author }}</span>
                </a>
              </div>
            </td>
            <td style="width: 15%">
              <div class="coverage-entity-cell">
                <app-star-toggle
                  [active]="isOutletSaved(item)"
                  [isLoading]="savingOutletId === item.outletId"
                  (toggled)="onOutletStarToggled(item, $event)"
                ></app-star-toggle>
                <a
                  class="coverage-entity-link"
                  href="javascript:;"
                  role="button"
                  (click)="getOutletContent(item)"
                  [pTooltip]="item.outlet"
                  tooltipPosition="top"
                >
                  <img
                    height="40px"
                    width="40px"
                    class="coverage-entity-avatar"
                    [src]="item.outletImageUrl"
                  />
                  <span class="coverage-entity-name">{{ item.outlet }}</span>
                </a>
              </div>
            </td>
            <td style="width: 25%">
              <div style="display: flex; align-items: center; gap: 4px;">
                <app-star-toggle
                  [active]="isArticleSaved(item)"
                  [isLoading]="savingArticleId === item.id"
                  (toggled)="onArticleStarToggled(item, $event)"
                ></app-star-toggle>
                <span
                  class="coverage-title p-list-title"
                  role="button"
                  (click)="goToTitleUrl(item.url)"
                >
                  <span
                    *ngIf="item.titleExcerpt"
                    [innerHTML]="item.titleExcerpt"
                  ></span>
                  <span *ngIf="!item.titleExcerpt && item.title">
                    {{ item.title }}
                  </span>
                </span>
              </div>
            </td>
            <td style="width: 35%">
              <span
                style="font-size: 0.7rem"
                class="p-list-title"
                role="button"
                [innerHTML]="item.bodyExcerpt"
                (click)="goToTitleUrl(item.url)"
              ></span>
            </td>
          </tr>
          <tr *ngIf="loading">
            <td style="width: 10%">
              <p-skeleton width="100%" height="1.5rem"></p-skeleton>
            </td>
            <td style="width: 15%">
              <p-skeleton width="100%" height="1.5rem"></p-skeleton>
            </td>
            <td style="width: 15%">
              <p-skeleton width="100%" height="1.5rem"></p-skeleton>
            </td>
            <td style="width: 25%">
              <p-skeleton width="100%" height="1.5rem"></p-skeleton>
            </td>
            <td style="width: 35%">
              <p-skeleton width="100%" height="1.5rem"></p-skeleton>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="!loading">
            <td colspan="4" class="text-center">No records found</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="pagination-footer">
        <div class="pagination-footer-left">
          <p-paginator
            #paginator
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{{ totalItems | number }} total items"
            [pageLinkSize]="3"
            [showFirstLastIcon]="false"
            (onPageChange)="getPage($event)"
            [rows]="pageSize"
            [totalRecords]="totalItems"
          >
          </p-paginator>
        </div>
        <div class="report-table-footer-actions">
          <p-dropdown
            [options]="exportOptions"
            placeholder="Export Coverage"
            optionLabel="label"
            optionValue="value"
            (onChange)="handleExport($event)"
            styleClass="reports-export-dropdown p-mr-2"
            [showClear]="false"
            appendTo="body"
            [ngModel]="selectedExportValue"
          >
            <ng-template pTemplate="selectedItem" let-selectedOption>
              <div class="export-selected-item">
                <i *ngIf="isExportingExcel" class="pi pi-spin pi-spinner"></i>
                <i *ngIf="isExportingText" class="pi pi-spin pi-spinner"></i>
                <i
                  *ngIf="!isExportingExcel && !isExportingText"
                  class="pi pi-fw pi-download"
                ></i>
                <span class="p-ml-2">Export Coverage</span>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-option>
              <div class="export-option-item">
                <i [class]="option.icon"></i>
                <span class="p-ml-2">{{ option.label }}</span>
              </div>
            </ng-template>
          </p-dropdown>
          <button
            pTooltip="Report Missing Data"
            pButton
            class="p-button-outlined p-button-secondary p-button-sm"
            icon="pi pi-flag"
            label=""
            (click)="openReportMissingDataModal()"
          ></button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<p-dialog
  header="Save Report"
  [(visible)]="showSaveReportDialog"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '450px', maxWidth: '95vw' }"
  [baseZIndex]="10000"
  (onShow)="saveReportTitleInput.focus(); saveReportTitleInput.select()"
>
  <div class="p-fluid">
    <div class="p-field">
      <label for="save-report-title">Report title</label>
      <input
        #saveReportTitleInput
        id="save-report-title"
        type="text"
        pInputText
        [(ngModel)]="saveReportTitle"
        (keydown.enter)="confirmSaveReport()"
        required
      />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      icon="pi pi-times"
      styleClass="p-button-raised p-button-secondary p-button-text"
      (click)="showSaveReportDialog = false"
    ></p-button>
    <p-button
      label="Save"
      icon="pi pi-save"
      [disabled]="!saveReportTitle.trim()"
      (click)="confirmSaveReport()"
    ></p-button>
  </ng-template>
</p-dialog>

<p-overlayPanel
  #newReportMenu
  [dismissable]="true"
  [showCloseIcon]="false"
  [appendTo]="'body'"
  styleClass="new-report-type-menu"
>
  <div class="new-report-type-options">
    <section *ngIf="savedReports.length" class="new-report-type-section">
      <h3 class="new-report-type-section__title">My Saved Reports</h3>
      <button
        *ngFor="let report of savedReports"
        type="button"
        class="shortcut-btn new-report-type-option"
        (click)="newReportMenu.hide(); selectSavedReport(report)"
      >
        {{ report.name }}
      </button>
    </section>

    <section class="new-report-type-section">
      <h3 class="new-report-type-section__title">Standard Reports</h3>
      <button
        *ngFor="let preset of standardChartTypeOptions"
        type="button"
        class="shortcut-btn new-report-type-option"
        (click)="newReportMenu.hide(); createStandardReport(preset.value)"
      >
        {{ preset.label }}
      </button>
    </section>

    <section class="new-report-type-section">
<!--      <h3 class="new-report-type-section__title">Custom</h3>-->
      <button
        type="button"
        class="shortcut-btn new-report-type-option"
        (click)="newReportMenu.hide(); createCustomReport()"
      >
        Custom Report...
      </button>
    </section>
  </div>
</p-overlayPanel>

<p-dialog
  [(visible)]="showChartSettings"
  (onHide)="onChartSettingsHide()"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw', maxWidth: '1100px' }"
  [baseZIndex]="10000"
  styleClass="chart-settings-dialog"
  header="Report Settings"
>
  <div class="chart-filters chart-filters--dialog" [formGroup]="chartSettingsForm">
    <p-fieldset legend="Basic Settings">
    <div class="chart-filters-row">
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <label class="chart-filter-label">Title</label>
        <input
          type="text"
          formControlName="title"
          class="chart-filter-input"
          style="width: 500px"
          (blur)="onChartSettingsTitleBlur()"
        />
      </div>
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <label class="chart-filter-label">Chart type</label>
        <p-dropdown
          id="coverage-report-chart-type-dropdown"
          formControlName="chartType"
          [options]="chartTypeOptions"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          (onChange)="onChartSettingsTypeChange()"
          styleClass="chart-filter-dropdown"
        ></p-dropdown>
      </div>
    </div>

    <div class="chart-filters-row">
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <label class="chart-filter-label">Within Topic</label>
        <p-dropdown
          id="coverage-report-domain-topic-dropdown"
          formControlName="domainTopic"
          [options]="topicOptions"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          (onChange)="onChartSettingsFilterChange()"
          styleClass="chart-filter-dropdown"
        ></p-dropdown>
      </div>
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <p-checkbox
          id="coverage-report-include-other-checkbox"
          formControlName="includeOther"
          [binary]="true"
          (onChange)="onChartSettingsFilterChange()"
          styleClass="chart-filter-checkbox"
        ></p-checkbox>
        <label class="chart-filter-label">Complete Topic Coverage</label>
      </div>
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <label class="chart-filter-label">Versus Competitors</label>
        <p-multiSelect
          id="coverage-report-competitor-topics-multiselect"
          formControlName="competitorTopics"
          [options]="competitorOptions"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          defaultLabel="Select Competitors"
          selectedItemsLabel="{0} selected"
          [maxSelectedLabels]="1"
          [filter]="false"
          (onChange)="onChartSettingsFilterChange()"
          styleClass="chart-filter-multiselect"
        ></p-multiSelect>
      </div>
    </div>
    <div class="chart-filters-row">
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <label class="chart-filter-label">Data Type</label>
        <p-dropdown
          id="coverage-report-data-type-dropdown"
          formControlName="dataType"
          [options]="dataTypeOptions"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          (onChange)="onChartSettingsFilterChange()"
          styleClass="chart-filter-dropdown"
        ></p-dropdown>
      </div>
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <label class="chart-filter-label">Timeframe</label>
        <p-dropdown
          id="coverage-report-timeframe-dropdown"
          formControlName="timeframe"
          [options]="timeframeOptions"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          (onChange)="onChartSettingsFilterChange()"
          styleClass="chart-filter-dropdown"
        ></p-dropdown>
      </div>
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <label class="chart-filter-label">Interval</label>
        <p-dropdown
          id="coverage-report-interval-dropdown"
          formControlName="interval"
          [options]="intervalOptions"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          (onChange)="onChartSettingsFilterChange()"
          styleClass="chart-filter-dropdown"
        ></p-dropdown>
      </div>
      <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
        <p-checkbox
          id="coverage-report-calendarYear-checkbox"
          formControlName="calendarYear"
          [binary]="true"
          (onChange)="onChartSettingsFilterChange()"
          styleClass="chart-filter-checkbox"
        ></p-checkbox>
        <label class="chart-filter-label">Calendar intervals</label>
      </div>
    </div>
    <div class="chart-filters-row">
      <div
        *ngIf="chartSettingsForm.value.timeframe === 'CUSTOM'"
        class="chart-filter-field p-d-flex p-ai-center"
        style="gap: 0.5rem"
      >
        <label class="chart-filter-label">From Date</label>
        <p-calendar
          id="coverage-report-from-date-calendar"
          formControlName="fromDate"
          inputId="coverage-report-from-date"
          placeholder="From date"
          dateFormat="mm/dd/yy"
          [showButtonBar]="true"
          [showIcon]="true"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          [maxDate]="chartSettingsForm.value.toDate"
          (onSelect)="onChartSettingsFilterChange()"
          (onInput)="onChartSettingsDateInput('fromDate', $event)"
          (onClearClick)="onChartSettingsDateClear('fromDate')"
        ></p-calendar>
      </div>
      <div
        *ngIf="chartSettingsForm.value.timeframe === 'CUSTOM'"
        class="chart-filter-field p-d-flex p-ai-center"
        style="gap: 0.5rem"
      >
        <label class="chart-filter-label">To Date</label>
        <p-calendar
          id="coverage-report-to-date-calendar"
          formControlName="toDate"
          inputId="coverage-report-to-date"
          placeholder="To date"
          dateFormat="mm/dd/yy"
          [showButtonBar]="true"
          [showIcon]="true"
          [appendTo]="'body'"
          [baseZIndex]="11000"
          [minDate]="chartSettingsForm.value.fromDate"
          (onSelect)="onChartSettingsFilterChange()"
          (onInput)="onChartSettingsDateInput('toDate', $event)"
          (onClearClick)="onChartSettingsDateClear('toDate')"
        ></p-calendar>
      </div>
    </div>
    </p-fieldset>

    <button
      type="button"
      class="report-settings-section-title report-settings-section-toggle"
      [attr.aria-expanded]="showDataFilters"
      aria-controls="coverage-report-data-filters"
      (click)="toggleDataFilters()"
      *ngIf="!showDataFilters"
    >
      Show Advanced Settings
      <i class="pi pi-chevron-down"></i>
    </button>
    <div id="coverage-report-data-filters" [hidden]="!showDataFilters">
      <p-fieldset legend="Chart Display">
      <div class="chart-filters-row">
        <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
          <p-checkbox
            id="coverage-report-display-values-checkbox"
            formControlName="displayNames"
            [binary]="true"
            (onChange)="onChartSettingsDisplayChange()"
            styleClass="chart-filter-checkbox"
          ></p-checkbox>
          <label class="chart-filter-label">Display names</label>
        </div>
        <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
          <p-checkbox
            id="coverage-report-display-values-checkbox"
            formControlName="displayValues"
            [binary]="true"
            (onChange)="onChartSettingsDisplayChange()"
            styleClass="chart-filter-checkbox"
          ></p-checkbox>
          <label class="chart-filter-label">Display values</label>
        </div>
        <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
          <p-checkbox
            id="coverage-report-display-values-checkbox"
            formControlName="hideZeroValues"
            [binary]="true"
            (onChange)="onChartSettingsDisplayChange()"
            styleClass="chart-filter-checkbox"
          ></p-checkbox>
          <label class="chart-filter-label">Hide zero values</label>
        </div>
        <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
          <p-checkbox
            id="coverage-report-forecast-checkbox"
            formControlName="forecast"
            [binary]="true"
            (onChange)="onChartSettingsFilterChange()"
            styleClass="chart-filter-checkbox"
          ></p-checkbox>
          <label class="chart-filter-label">Forecast current period</label>
        </div>
        <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
          <p-checkbox
            id="coverage-report-include-other-checkbox"
            formControlName="showPieChart"
            [binary]="true"
            (onChange)="onChartSettingsDisplayChange()"
            styleClass="chart-filter-checkbox"
          ></p-checkbox>
          <label class="chart-filter-label">Display Pie Chart</label>
        </div>
        <div class="chart-filter-field p-d-flex p-ai-center" style="gap: 0.5rem">
          <p-checkbox
            id="coverage-report-show-intersections-checkbox"
            formControlName="showIntersections"
            [binary]="true"
            (onChange)="onChartSettingsFilterChange()"
            styleClass="chart-filter-checkbox"
          ></p-checkbox>
          <label class="chart-filter-label">Display intersections</label>
        </div>
      </div>
      </p-fieldset>

      <app-advanced-search
        #reportSearchFilters
        [embedded]="true"
        [visible]="showChartSettings"
        [filterType]="'COVERAGE_REPORT'"
        [searchFilters]="activeSearchFilters"
        (coverageFilters)="onCoverageFilters($event)"
        (outletGroupOptionsChange)="onOutletGroupOptionsChange($event)"
      ></app-advanced-search>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      pRipple
      icon="pi pi-times"
      (click)="onChartSettingsCancel()"
      label="Cancel"
      styleClass="p-button-raised p-button-secondary p-button-text"
    ></p-button>
    <p-button
      pRipple
      icon="pi pi-check"
      (click)="onChartSettingsApply()"
      label="Apply"
      styleClass="p-button-raised report-settings-apply-btn"
    ></p-button>
  </ng-template>
</p-dialog>
